/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @description
 *
 * @created at Tue Jan 17 2023
 **/

export type keys = "xs" | "s" | "m" | "l" | "xl";

export type values = { width: number; column: number };

export type IBreakPoint = {
	[size in keys]: values;
};

export const breakPoint: IBreakPoint = {
	xs: {
		width: 300,
		column: 1
	},
	s: {
		width: 600,
		column: 2
	},
	m: {
		width: 900,
		column: 3
	},
	l: {
		width: 1200,
		column: 4
	},
	xl: {
		width: 1500,
		column: 5
	}
};

export const createBreakPoint = (breakPoint: values) => {
	const { width } = breakPoint;

	return {
		breakPointUp: `@media (min-width: ${width}px)`,
		breakPointDown: `@media (max-width: ${width}px)`,
		...breakPoint
	};
};
